export {
  extractQueryParams,
  serializeQueryParams
};

function extractQueryParams() {
  return parseQueryString();
}

function parseQueryString() {
  const queryString = (window.location.hash || '').replace('#', '');

  return queryString.split('&')
    .filter(pair => !!pair && ~pair.indexOf('='))
    .map(pair => pair.split('='))
    .reduce((aggregated, current = []) => {
      const normalizedKey = current[0].replace(/(-|\.|\s)+(.)?/g, function(match, separator, chr) {
        return chr ? chr.toUpperCase() : '';
      });
      let value = current[1];
      if (value === '' || value === 'null' || value === 'undefined') {
        value = null;
      }
      aggregated[normalizedKey] = value;
      return aggregated;
    }, {});
}

function serializeQueryParams(queryParams, defaults = {}) {
  const normalizedQueryParams = normalizeQueryParams(queryParams, defaults);
  const query = buildQuery(normalizedQueryParams);
  window.history.replaceState(normalizedQueryParams, document.title, query);
}

function buildQuery(queryParams) {
  const query = Object.entries(queryParams).map(([key, value]) => {
    const normalizedKey = key.replace(/([a-z\d])([A-Z])/g, '$1-$2').toLowerCase();
    return `${normalizedKey}=${value}`;
  }).join('&');
  return query ? `/#${query}` : '/';
}

function normalizeQueryParams(queryParams = {}, defaults = {}) {
  const result = {};
  Object.entries(queryParams).forEach(([key, value]) => {
    if (defaults[key] !== value) {
      result[key] = value;
    }
  });
  return result;
}




// WEBPACK FOOTER //
// ./src/shared/utils/src/query-params.js